// import request from '@/services/request'
// import api from '@/services/api'
const state = {
  adPromotionData: {}, // 跳转到广告组页面（二级页面） 携带参数
  adGroupData: {}, // 跳转三级页面 携带参数
  portfolioId: '',
  advertAnalyseFormRestore: {},
  advertAnalyseShopOptions: [],
  mapAccount: [{
    countryCode: 'US',
    minBudget: 1,
    maxBudget: 1000000,
    minBid: 0.02,
    maxBid: 1000,
    defaultBid: 0.75,
  },
  {
    countryCode: 'CA',
    minBudget: 1,
    maxBudget: 1000000,
    minBid: 0.02,
    maxBid: 1000,
    defaultBid: 0.6,
  },
  {
    countryCode: 'MX',
    minBudget: 1,
    maxBudget: 21000000,
    minBid: 0.1,
    maxBid: 20000,
    defaultBid: '',
  },
  {
    countryCode: 'BR',
    minBudget: '',
    minBid: 0.07,
    maxBid: 1100,
    defaultBid: '',
  },
  {
    countryCode: 'UK',
    minBudget: 1,
    maxBudget: 1000000,
    minBid: 0.02,
    maxBid: 1000,
    defaultBid: 0.5,
  },
  {
    countryCode: 'FR',
    minBudget: 1,
    maxBudget: 1000000,
    minBid: 0.02,
    maxBid: 1000,
    defaultBid: 0.4,
  },
  {
    countryCode: 'DE',
    minBudget: 1,
    maxBudget: 1000000,
    minBid: 0.02,
    maxBid: 1000,
    defaultBid: 0.4,
  },
  {
    countryCode: 'IT',
    minBudget: 1,
    maxBudget: 1000000,
    minBid: 0.02,
    maxBid: 1000,
    defaultBid: 0.3,
  },
  {
    countryCode: 'SE',
    minBudget: 9,
    maxBudget: 9300000,
    minBid: 0.18,
    maxBid: 9300,
    defaultBid: 6.9,
  },
  {
    countryCode: 'PL',
    minBudget: 2,
    minBid: 0.04,
    maxBid: 2000,
    defaultBid: 1.45,
  },
  {
    countryCode: 'TR',
    minBudget: '',
    minBid: 0.05,
    maxBid: 2500,
    defaultBid: '',
  },
  {
    countryCode: 'NL',
    minBudget: 1,
    maxBudget: 1000000,
    minBid: 0.02,
    maxBid: 1000,
    defaultBid: 0.55,
  },
  {
    countryCode: 'SP',
    minBudget: 1,
    maxBudget: 1000000,
    minBid: 0.02,
    maxBid: 1000,
    defaultBid: 0.3,
  },
  {
    countryCode: 'JP',
    minBudget: 100,
    maxBudget: 21000000,
    minBid: 2,
    maxBid: 100000,
    defaultBid: 40
  },
  {
    countryCode: 'AU',
    minBudget: 1.4,
    maxBudget: 1500000,
    minBid: 0.1,
    maxBid: 1410,
    defaultBid: 1,
  },
  {
    countryCode: 'SG',
    minBudget: '',
    minBid: 0.02,
    maxBid: 1100,
    defaultBid: '',
  },
  {
    countryCode: 'IN',
    minBudget: '',
    minBid: 1,
    maxBid: 5000,
    defaultBid: '',
  },
  {
    countryCode: 'SA',
    minBudget: 4,
    maxBudget: 3700000,
    minBid: 0.1,
    maxBid: 3670,
    defaultBid: 4,
  },
  {
    countryCode: 'AE',
    minBudget: '',
    minBid: 0.24,
    maxBid: 184,
    defaultBid: '',
  },
  ],
}

const mutations = {
  SET_ADPROMOTIONPARAMS: (state, data) => {
    state.adPromotionData = data
  },
  SET_ADGROUPPARAMS: (state, data) => {
    state.adGroupData = data
  },
  SET_PORTFOLIOID(state, data) {
    state.portfolioId = data
  },
  SET_ADVERTANALYSEFORMRESTORE(state, data) {
    state.advertAnalyseFormRestore = data
    console.log(data, 'data')
  },
  SET_ADVERTANALYSESHOPOPTIONS(state, data) {
    state.advertAnalyseShopOptions = data
  }
}

const actions = {
}

export default {
  namespaced: true,
  state,
  mutations,
  actions
}
